export default "301c2ccdbe3b58d4.png"